<template>
  <div class="container-fluid demand-form">
    <loading :active.sync="isLoading" :enforce-focus="false" loader="dots" />

    <div class="page-tab">
      <!-- 申請資訊 -->
      <a
        style="cursor: auto"
        href="javascript:void(0)"
        class="tab"
        :class="{ active: currentStep >= 1 }"
        ><span class="num">01</span
        ><span class="name">{{ i18n("DemandApply.ApplyData") }}</span></a
      >
      <!-- 需求資訊 -->
      <a
        style="cursor: auto"
        href="javascript:void(0)"
        class="tab"
        :class="{ active: currentStep >= 2 }"
        ><span class="num">02</span
        ><span class="name">{{ i18n("DemandApply.DemandData") }}</span></a
      >
      <!-- 職務說明 -->
      <a
        style="cursor: auto"
        href="javascript:void(0)"
        class="tab"
        :class="{ active: currentStep >= 3 }"
        ><span class="num">03</span
        ><span class="name">{{ i18n("DemandApply.JobData") }}</span></a
      >
      <!-- 學歷條件 -->
      <a
        style="cursor: auto"
        href="javascript:void(0)"
        class="tab"
        :class="{ active: currentStep >= 4 }"
        ><span class="num">04</span
        ><span class="name">{{
          i18n("DemandApply.DegreeRequirement")
        }}</span></a
      >
      <!-- 經歷條件 -->
      <a
        style="cursor: auto"
        href="javascript:void(0)"
        class="tab"
        :class="{ active: currentStep >= 5 }"
        ><span class="num">05</span
        ><span class="name">{{
          i18n("DemandApply.ExperienceRequirement")
        }}</span></a
      >
    </div>

    <div class="tab-content">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form
          @submit.prevent="
            (manpowerDemandStatus = 'New'), handleSubmit(saveDemand)
          "
        >
          <!-- 1. 申請資訊 -->
          <fieldset v-if="currentStep === 1">
            <div class="tab-section tab-01">
              <div class="tab-name">
                <div class="name-inner">
                  <span>1</span>
                  {{ i18n("DemandApply.ApplyData") }}
                </div>
              </div>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <!-- 申請日期 -->
                    <th id="applyDate" class="width-15 text-right">
                      {{ i18n("Basic.ApplyDate") }}
                    </th>
                    <td class="width-35">
                      {{ $common.dateFormatter(demandApply.ApplicantTime) }}
                    </td>

                    <!-- 申請者 -->
                    <td class="width-15 text-right">
                      {{ i18n("Basic.ApplyUser") }}
                    </td>
                    <td class="width-35">{{ demandApply.Applicant }}</td>
                  </tr>

                  <!-- 申請部門 -->
                  <tr>
                    <td colspan="1" class="text-right">
                      <span class="mark">*</span
                      >{{ i18n("Basic.ApplyDepartment") }}
                    </td>
                    <td colspan="3">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <treeselect
                          :options="departmentOptions"
                          :searchable="true"
                          :show-count="true"
                          :default-expand-level="1"
                          placeholder="請選擇"
                          v-model="demandApply.DemandDepartmentGuid"
                        >
                          <label
                            for="count"
                            slot="option-label"
                            slot-scope="{
                              node,
                              shouldShowCount,
                              count,
                              labelClassName,
                              countClassName,
                            }"
                            :class="labelClassName"
                          >
                            {{ node.label }}
                            <span
                              v-if="shouldShowCount"
                              :class="countClassName"
                            >
                              ({{ count }})
                            </span>
                          </label>
                        </treeselect>
                        <span v-if="errors[0]" class="text-danger">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="1" class="text-right">
                      <span class="mark">*</span>職缺名稱
                    </td>
                    <td colspan="3">
                      <ValidationProvider
                        name="職缺名稱"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <el-input
                          clearable
                          type="textarea"
                          :rows="3"
                          maxlength="200"
                          placeholder="請輸入"
                          v-model.trim="demandApply.ManpowerDemandName"
                        />
                        <span v-if="errors[0]" class="text-danger">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <tr>
                    <!-- 履歷類型 -->
                    <td class="width-15 text-right">
                      <span class="mark">*</span>
                      {{ i18n("DemandApply.ResumeType") }}
                    </td>
                    <td class="width-35">
                      <ValidationProvider
                        name="履歷類型"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <el-select
                          class="w-100"
                          placeholder="請選擇"
                          v-model="demandApply.ResumeType"
                        >
                          <el-option
                            v-for="resume in resumeTypeOptions"
                            :key="resume.Type"
                            :label="resume.Name"
                            :value="resume.Type"
                          >
                          </el-option>
                        </el-select>
                        <span v-if="errors[0]" class="text-danger">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>

                    <!-- 招募期限 -->
                    <td class="width-15 text-right">
                      <span class="mark">*</span>
                      {{ i18n("DemandApply.RecruitDeadline") }}
                    </td>
                    <td class="width-35">
                      <ValidationProvider
                        name="招募期限"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <el-date-picker
                          class="w-100"
                          type="date"
                          value-format="yyyy-MM-dd"
                          :picker-options="{
                            disabledDate: $common.disabledDateBeforeToday,
                          }"
                          placeholder="yyyy-MM-DD"
                          v-model="demandApply.RecruitmentDeadline"
                        />
                        <span v-if="errors[0]" class="text-danger">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>

          <!-- 2. 需求資訊 -->
          <fieldset v-if="currentStep === 2">
            <div class="tab-section tab-02">
              <div class="tab-name">
                <div class="name-inner">
                  <span>2</span>
                  {{ i18n("DemandApply.DemandData") }}
                </div>
              </div>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <!-- 職務性質 -->
                    <th id="jobType" class="text-right">
                      {{ i18n("DemandApply.JobType") }}
                    </th>
                    <td colspan="3">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="全職"
                            v-model="demandApply.PositionProperty"
                          />
                          {{ i18n("DemandApply.FullTime") }}
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="兼職"
                            v-model="demandApply.PositionProperty"
                          />

                          {{ i18n("DemandApply.PartTime") }}
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="高階"
                            v-model="demandApply.PositionProperty"
                          />
                          {{ i18n("DemandApply.HighLevel") }}
                        </label>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <!-- 職務名稱 -->
                    <td class="text-right">
                      <span class="mark">*</span>
                      {{ i18n("Position.PositionName") }}
                    </td>
                    <td colspan="3">
                      <ValidationProvider
                        name="職務名稱"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <el-select
                          class="w-100"
                          filterable
                          value-key="PositionCode"
                          placeholder="請選擇"
                          v-model="positionValue"
                        >
                          <el-option
                            v-for="position in positionOptions"
                            :key="position.PositionCode"
                            :label="position.PositionName"
                            :value="position"
                          >
                          </el-option>
                        </el-select>
                        <span v-if="errors[0]" class="text-danger">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <tr>
                    <!-- 需求人數 -->
                    <td class="text-right">
                      <span class="mark">*</span
                      >{{ i18n("DemandApply.DemandNumber") }}
                    </td>
                    <td>
                      <ValidationProvider
                        :name="i18n('DemandApply.DemandNumber')"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <el-input-number
                          class="w-100"
                          :min="1"
                          :max="99999"
                          v-model.number="demandApply.DemandNumber"
                        />
                        <span v-if="errors[0]" class="text-danger ml-1">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>

                    <!-- 預定任職日 -->
                    <td class="text-right">
                      {{ i18n("DemandApply.DateOfAppointment") }}
                    </td>
                    <td>
                      <el-date-picker
                        class="w-100"
                        type="date"
                        value-format="yyyy-MM-dd"
                        :picker-options="{
                          disabledDate: $common.disabledDateBeforeToday,
                        }"
                        placeholder="yyyy-MM-DD"
                        v-model="demandApply.OnBoard"
                      />
                    </td>
                  </tr>

                  <tr>
                    <!-- 招募方式 -->
                    <td class="text-right">
                      {{ i18n("DemandApply.RecruitMethod") }}
                    </td>
                    <td colspan="3">
                      <div
                        v-for="item in recruitmentMethodOptions"
                        :key="item.RecruitmentMethodGuid"
                        class="form-check form-check-inline"
                      >
                        <label class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :value="item"
                            v-model="
                              demandApply.ManpowerDemandRecruitmentMethod
                            "
                          />
                          {{ item.RecruitmentMethod }}
                        </label>
                      </div>
                      <div
                        v-if="recruitmentMethodOtherStatus"
                        style="margin-top: 10px"
                      >
                        <ValidationProvider
                          name="招募方式描述"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          <el-input
                            type="textarea"
                            :rows="3"
                            maxlength="100"
                            show-word-limit
                            placeholder="請輸入招募方式"
                            v-model.trim="recruitmentMethodDescription"
                          />
                          <span v-if="errors[0]" class="text-danger">
                            {{ errors[0] }}
                          </span>
                        </ValidationProvider>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <!-- 聘僱合約類別 -->
                    <td class="text-right">
                      {{ i18n("DemandApply.ContractType") }}
                    </td>
                    <td colspan="3">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            type="radio"
                            class="form-check-input"
                            value="一般"
                            v-model="demandApply.ContractType"
                          />
                          一般
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            type="radio"
                            class="form-check-input"
                            value="競業禁止"
                            v-model="demandApply.ContractType"
                          />
                          競業禁止
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            type="radio"
                            class="form-check-input"
                            value="鐘點計時"
                            v-model="demandApply.ContractType"
                          />
                          鐘點計時
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            type="radio"
                            class="form-check-input"
                            value="定期合約"
                            v-model="demandApply.ContractType"
                          />
                          定期合約
                        </label>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>

          <!-- 3. 職務說明 -->
          <fieldset v-if="currentStep === 3">
            <div class="tab-section tab-03">
              <div class="tab-name">
                <div class="name-inner">
                  <span>3</span>
                  {{ i18n("DemandApply.JobData") }}
                </div>
              </div>
              <table class="table table-bordered">
                <tbody>
                  <!-- 工作地點 -->
                  <tr>
                    <th id="jobLocation" class="text-right">
                      <span class="mark">*</span>
                      {{ i18n("DemandApply.JobLocation") }}
                    </th>
                    <td colspan="4">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <el-select
                          class="w-100"
                          multiple
                          filterable
                          value-key="WorkPlaceGuid"
                          placeholder="請選擇"
                          v-model="demandApply.ManpowerDemandWorkPlace"
                        >
                          <el-option
                            v-for="workplace in workplaceOptions"
                            :key="workplace.WorkPlaceGuid"
                            :label="workplace.WorkPlace"
                            :value="workplace"
                          >
                          </el-option>
                        </el-select>
                        <span v-if="errors[0]" class="text-danger ml-1">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <!-- 工作內容 -->
                  <tr>
                    <td class="text-right">
                      <span class="mark">*</span
                      >{{ i18n("DemandApply.JobResponsibility") }}
                    </td>
                    <td colspan="3">
                      <ValidationProvider
                        mode="lazy"
                        rules="required"
                        :name="i18n('DemandApply.JobResponsibility')"
                        v-slot="{ errors }"
                      >
                        <el-input
                          type="textarea"
                          :rows="8"
                          show-word-limit
                          v-model.trim="demandApply.WorkContent"
                        />
                        <span v-if="errors[0]" class="text-danger ml-1">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <!-- 說明 -->
                  <tr>
                    <td class="text-right">
                      {{ i18n("DemandApply.Description") }}
                    </td>
                    <td colspan="3">
                      <el-input
                        type="textarea"
                        :rows="8"
                        show-word-limit
                        v-model.trim="demandApply.Description"
                      />
                    </td>
                  </tr>

                  <!-- 班別 -->
                  <tr>
                    <td class="text-right">
                      {{ i18n("DemandApply.ShiftType") }}
                    </td>
                    <td colspan="3">
                      <div
                        v-for="item in shiftOptions"
                        :key="item.WorkShiftTypeGuid"
                        class="form-check"
                      >
                        <label class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            :value="item"
                            v-model="demandApply.ManpowerDemandWorkShiftType"
                          />
                          {{ item.WorkShiftType }}
                        </label>
                        <el-input
                          class="w-100"
                          clearable
                          maxlength="200"
                          placeholder="請填寫詳細時段或排班資訊"
                          v-model.trim="item.WorkShiftTypeDescription"
                        />
                      </div>
                    </td>
                  </tr>

                  <!-- 輪班 -->
                  <tr>
                    <td class="text-right">{{ i18n("DemandApply.Shifts") }}</td>
                    <td colspan="3">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="demandApply.Shift"
                          />
                          {{ i18n("DemandApply.Require") }}
                        </label>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <!-- 出差 -->
                    <td class="width-15 text-right">
                      {{ i18n("DemandApply.BusinessTrip") }}
                    </td>
                    <td class="width-35">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="demandApply.BusinessTrip"
                          />
                          {{ i18n("DemandApply.Require") }}
                        </label>
                      </div>
                    </td>

                    <!-- 外派 -->
                    <td class="width-15 text-right">
                      {{ i18n("DemandApply.Expat") }}
                    </td>
                    <td class="width-35">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="demandApply.OverseasWork"
                          />
                          {{ i18n("DemandApply.Require") }}
                        </label>
                      </div>
                    </td>
                  </tr>

                  <!-- 管理責任 -->
                  <tr>
                    <td class="text-right">
                      {{ i18n("DemandApply.ManagementResponsibility") }}
                    </td>
                    <td colspan="3">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            type="checkbox"
                            class="form-check-input"
                            v-model="demandApply.ManagementResponsibility"
                          />
                          {{ i18n("DemandApply.Require") }}
                          (若勾選，請填寫管理人數)
                        </label>
                      </div>
                      <div
                        v-if="demandApply.ManagementResponsibility"
                        class="form-inline"
                      >
                        <ValidationProvider
                          class="w-100"
                          rules="required"
                          name="管理人數"
                          v-slot="{ errors }"
                        >
                          <el-input-number
                            class="w-100"
                            :min="1"
                            :max="99999"
                            v-model.number="demandApply.ManagementNumber"
                          />
                          <div>
                            <span class="text-danger" v-if="errors[0]">
                              {{ errors[0] }}
                            </span>
                          </div>
                        </ValidationProvider>
                      </div>
                    </td>
                  </tr>

                  <!-- 薪資類型 -->
                  <tr>
                    <td class="text-right">
                      <span class="mark">*</span>
                      薪資類型
                    </td>
                    <td colspan="3">
                      <ValidationProvider rules="required" v-slot="{ errors }">
                        <el-select
                          class="w-100"
                          value-key="Guid"
                          placeholder="請選擇"
                          v-model="salaryTypeValue"
                        >
                          <el-option
                            v-for="salaryType in salaryTypeOptions"
                            :key="salaryType.Guid"
                            :label="salaryType.Name"
                            :value="salaryType"
                          >
                          </el-option>
                        </el-select>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                      <ValidationProvider
                        v-if="
                          salaryTypeValue && salaryTypeValue.Code === 'other'
                        "
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <input
                          type="text"
                          class="form-control"
                          style="margin-top: 5px"
                          placeholder="請填寫薪資類型"
                          v-model="demandApply.SalaryTypeDescription"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <!-- 薪資待遇 -->
                  <tr>
                    <td class="text-right">薪資待遇</td>
                    <td colspan="3">
                      <div class="form-row">
                        <div class="col-md">
                          <ValidationProvider
                            tag="section"
                            name="薪資待遇(低)"
                            :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                            v-slot="{ errors }"
                          >
                            <input
                              type="text"
                              class="form-control text-right"
                              v-model.trim="demandApply.SalaryLow"
                            />
                            <span class="text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                        ~
                        <div class="col-md">
                          <ValidationProvider
                            tag="section"
                            name="薪資待遇(高)"
                            :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                            v-slot="{ errors }"
                          >
                            <input
                              type="text"
                              class="form-control text-right"
                              v-model.trim="demandApply.SalaryHigh"
                            />
                            <span class="text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <!-- 預設職稱 -->
                  <tr v-if="demandApply.ResumeType === 'DL'">
                    <td class="text-right">預設職稱</td>
                    <td colspan="3">
                      <el-select
                        class="w-100"
                        filterable
                        placeholder="請選擇"
                        v-model="demandApply.AppointmentDefaultPosition"
                      >
                        <el-option label="生產助理員" value="生產助理員" />
                        <el-option label="助理" value="助理" />
                        <el-option label="技術助理員" value="技術助理員" />
                        <el-option label="技術員" value="技術員" />
                        <el-option label="高級技術員" value="高級技術員" />
                        <el-option label="事務員" value="事務員" />
                        <el-option label="資深技術員" value="資深技術員" />
                        <el-option label="組長" value="組長" />
                        <el-option label="儲備組長" value="儲備組長" />
                        <el-option label="工讀生" value="工讀生" />
                        <el-option label="實習生" value="實習生" />
                        <el-option label="按摩師" value="按摩師" />
                      </el-select>
                    </td>
                  </tr>

                  <!-- 預設職等 -->
                  <tr v-if="demandApply.ResumeType === 'DL'">
                    <td class="text-right">預設職等</td>
                    <td colspan="3">
                      <el-select
                        class="w-100"
                        placeholder="請選擇"
                        v-model="demandApply.AppointmentDefaultRank"
                      >
                        <el-option label="1" value="1" />
                        <el-option label="2" value="2" />
                        <el-option label="2.1" value="2.1" />
                        <el-option label="2.2" value="2.2" />
                        <el-option label="3" value="3" />
                        <el-option label="4" value="4" />
                        <el-option label="5" value="5" />
                        <el-option label="6" value="6" />
                        <el-option label="6.3" value="6.3" />
                        <el-option label="7" value="7" />
                        <el-option label="7.3" value="7.3" />
                        <el-option label="8" value="8" />
                        <el-option label="8.3" value="8.3" />
                        <el-option label="9" value="9" />
                        <el-option label="9.3" value="9.3" />
                        <el-option label="10" value="10" />
                        <el-option label="10.3" value="10.3" />
                        <el-option label="10.5" value="10.5" />
                        <el-option label="10.7" value="10.7" />
                        <el-option label="11" value="11" />
                        <el-option label="11.3" value="11.3" />
                        <el-option label="11.5" value="11.5" />
                        <el-option label="12" value="12" />
                        <el-option label="13" value="13" />
                        <el-option label="13.3" value="13.3" />
                      </el-select>
                    </td>
                  </tr>

                  <!-- 預設薪資 -->
                  <tr v-if="demandApply.ResumeType === 'DL'">
                    <td class="text-right">預設薪資</td>
                    <td colspan="3">
                      <ValidationProvider
                        class="w-100"
                        name="預設薪資"
                        :rules="{ regex: new RegExp(/^([0-9,]+)$/) }"
                        v-slot="{ errors }"
                      >
                        <input
                          class="form-control text-right"
                          type="text"
                          v-model.trim="demandApply.AppointmentDefaultSalary"
                        />
                        <span v-if="errors" class="text-danger">
                          {{ errors[0] }}
                        </span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <!-- 預設身份別 -->
                  <tr>
                    <td class="text-right">
                      <span class="mark">*</span>
                      預設身份別
                    </td>
                    <td colspan="3">
                      <ValidationProvider
                        class="w-100"
                        name="預設身份別"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <el-select
                          class="w-100"
                          clearable
                          filterable
                          placeholder="請選擇"
                          v-model="demandApply.AppointmentDefaultIdentityType"
                        >
                          <el-option label="IDL" value="IDL" />
                          <el-option label="IDL工讀生" value="IDL工讀生" />
                          <el-option label="DL" value="DL" />
                          <el-option label="按摩師" value="按摩師" />
                          <el-option
                            label="DL產學合作4+2產學生(高中畢業)"
                            value="DL產學合作4+2產學生(高中畢業)"
                          />
                          <el-option
                            label="DL產學合作1年期實習生(大四學生)"
                            value="DL產學合作1年期實習生(大四學生)"
                          />
                          <el-option label="外籍" value="外籍" />
                        </el-select>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <!-- 職務聯絡人 -->
                  <tr>
                    <td class="text-right">
                      <span class="mark">*</span>
                      職務聯絡人
                    </td>
                    <td colspan="3">
                      <ValidationProvider
                        class="w-100"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <el-select
                          class="w-100"
                          filterable
                          allow-create
                          clearable
                          value-key="Email"
                          placeholder="請選擇"
                          @change="changeContactor"
                          v-model="demandApply.PositionContactor"
                        >
                          <el-option
                            v-for="contactor in contactorOptions"
                            :key="contactor.Email"
                            :label="contactor.Name"
                            :value="contactor"
                          >
                          </el-option>
                        </el-select>
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <!-- 聯絡人Email -->
                  <tr>
                    <td class="text-right">
                      <span class="mark">*</span>
                      聯絡人Email
                    </td>
                    <td colspan="3">
                      <ValidationProvider
                        class="w-100"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <el-input
                          class="w-100"
                          clearable
                          maxlength="200"
                          v-model.trim="demandApply.PositionContactorEmail"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>

          <!-- 4. 學歷條件 -->
          <fieldset v-if="currentStep === 4">
            <div class="tab-section tab-05">
              <div class="tab-name">
                <div class="name-inner">
                  <span>4</span>
                  {{ i18n("DemandApply.DegreeRequirement") }}
                </div>
              </div>
              <table class="table table-bordered">
                <tbody>
                  <!-- 學歷 -->
                  <tr>
                    <th id="degree" class="width-15 text-right">
                      <span class="mark">*</span>
                      {{ i18n("DemandApply.Degree") }}
                    </th>
                    <td>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="demandApply.EducationDemandWhatever"
                          />
                          不拘
                        </label>
                      </div>

                      <div v-if="!demandApply.EducationDemandWhatever">
                        <ValidationProvider
                          rules="required"
                          v-slot="{ failed }"
                        >
                          <div
                            v-for="item in educationDegreeOptions"
                            :key="item.Guid"
                            class="form-check form-check-inline"
                          >
                            <label class="form-check-label">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                :value="item"
                                v-model="
                                  demandApply.ManpowerDemandEducationDegree
                                "
                              />
                              {{ item.EducationDegree }}
                            </label>
                          </div>
                          <span class="text-danger ml-2" v-if="failed">
                            請選擇學歷要求
                          </span>
                        </ValidationProvider>
                      </div>
                    </td>
                  </tr>

                  <!-- 科系 -->
                  <tr>
                    <td class="text-right">
                      {{ i18n("DemandApply.Major") }}
                    </td>
                    <td>
                      <div
                        v-for="(
                          majorItem, index
                        ) in demandApply.ManpowerDemandSchoolDepartment"
                        :key="index"
                        style="margin-bottom: 20px"
                      >
                        <span class="language-title">
                          {{ majorItem.SchoolDepartmentType }}
                        </span>
                        <h6 style="margin-bottom: 12px">
                          <span class="language-text">
                            {{
                              majorItem.SchoolDepartment
                                ? majorItem.SchoolDepartment
                                : null
                            }}
                            <span v-if="majorItem.SchoolDepartmentDescription">
                              ｜科系描述：{{
                                majorItem.SchoolDepartmentDescription
                              }}
                            </span>
                            <button
                              type="button"
                              class="btn btn-danger btn-sm"
                              @click="deleteItem(index, 'Education')"
                            >
                              <eva-icon fill="#FFF" name="trash-2-outline" />
                            </button>
                          </span>
                        </h6>
                      </div>
                      <div>
                        <AddMajor
                          v-if="addMajor"
                          @addMajor="saveItem"
                          @addCancel="cancelItem('Education')"
                        />
                        <button
                          v-else
                          type="button"
                          class="btn btn-primary btn-sm"
                          @click="addItem('Education')"
                        >
                          <i class="fas fa-plus"></i>
                          {{ i18n("DemandApply.Major") }}
                        </button>
                      </div>
                    </td>
                  </tr>

                  <!-- 外語 -->
                  <tr>
                    <td class="text-right">
                      {{ i18n("DemandApply.Language") }}
                    </td>
                    <td>
                      <div
                        v-for="(
                          languageItem, index
                        ) in demandApply.ManpowerDemandLanguage"
                        :key="index"
                        style="margin-bottom: 20px"
                      >
                        <span
                          v-if="languageItem.LanguageDescription"
                          class="language-title"
                        >
                          {{ languageItem.LanguageDescription }}
                        </span>
                        <span v-else class="language-title">
                          {{ languageItem.Language }}
                        </span>
                        <h6 style="margin-bottom: 12px">
                          <span class="language-text"
                            >{{ i18n("Language.Listen") }}：{{
                              languageItem.Listen
                            }}</span
                          >｜
                          <span class="language-text"
                            >{{ i18n("Language.Speak") }}：{{
                              languageItem.Speak
                            }}</span
                          >｜
                          <span class="language-text"
                            >{{ i18n("Language.Read") }}：{{
                              languageItem.Read
                            }}</span
                          >｜
                          <span class="language-text"
                            >{{ i18n("Language.Write") }}：{{
                              languageItem.Write
                            }}</span
                          >
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            @click="deleteItem(index, 'Language')"
                          >
                            <eva-icon fill="#FFF" name="trash-2-outline" />
                          </button>
                        </h6>
                      </div>
                      <AddLanguage
                        v-if="addLanguage"
                        @addLanguage="saveItem"
                        @addCancel="cancelItem('Language')"
                      />
                      <button
                        v-else
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="addItem('Language')"
                      >
                        <i class="fas fa-plus"></i>
                        {{ i18n("DemandApply.Language") }}
                      </button>
                    </td>
                  </tr>

                  <!-- 方言 -->
                  <tr>
                    <td class="text-right">
                      {{ i18n("DemandApply.Dialect") }}
                    </td>
                    <td>
                      <div
                        v-for="(
                          dialectItem, index
                        ) in demandApply.ManpowerDemandDialect"
                        :key="index"
                        style="margin-bottom: 20px"
                      >
                        <span
                          v-if="dialectItem.DialectDescription"
                          class="language-title"
                        >
                          {{ dialectItem.DialectDescription }}
                        </span>
                        <span v-else class="language-title">
                          {{ dialectItem.Dialect }}
                        </span>
                        <h6 style="margin-bottom: 12px">
                          <span class="language-text">
                            程度：
                            {{ dialectItem.Degree }}
                          </span>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            @click="deleteItem(index, 'Dialect')"
                          >
                            <eva-icon fill="#FFF" name="trash-2-outline" />
                          </button>
                        </h6>
                      </div>
                      <AddDialect
                        v-if="addDialect"
                        @addDialect="saveItem"
                        @addCancel="cancelItem('Dialect')"
                      />
                      <button
                        v-else
                        type="button"
                        class="btn btn-primary btn-sm"
                        @click="addItem('Dialect')"
                      >
                        <i class="fas fa-plus"></i>
                        {{ i18n("DemandApply.Dialect") }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>

          <!-- 5. 經歷條件 -->
          <fieldset v-if="currentStep === 5">
            <div class="tab-section tab-04">
              <div class="tab-name">
                <div class="name-inner">
                  <span>5</span>
                  {{ i18n("DemandApply.ExperienceRequirement") }}
                </div>
              </div>
              <table class="table table-bordered">
                <tbody>
                  <tr>
                    <th id="experience" colspan="1" class="text-right">
                      <span class="mark">*</span>
                      工作經驗
                    </th>
                    <td colspan="3">
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="demandApply.WorkExperienceWhatever"
                          />
                          不拘
                        </label>
                      </div>

                      <div
                        v-if="!demandApply.WorkExperienceWhatever"
                        class="form-inline"
                      >
                        <ValidationProvider
                          name="年資要求"
                          rules="required"
                          v-slot="{ errors }"
                        >
                          年資要求：
                          <el-input-number
                            class="w-100"
                            :min="1"
                            :max="99"
                            v-model.number="demandApply.WorkExperience"
                          />
                          <p v-if="errors[0]" class="text-danger">
                            {{ errors[0] }}
                          </p>
                        </ValidationProvider>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="width-15 text-right">年齡</td>
                    <td>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            v-model="demandApply.AgeRangeWhatever"
                          />
                          不拘
                        </label>
                      </div>
                      <div
                        v-if="!demandApply.AgeRangeWhatever"
                        class="form-row"
                      >
                        <div class="col-md">
                          <ValidationProvider
                            tag="section"
                            name="年齡(最低)"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <el-input-number
                              class="w-100"
                              :min="18"
                              :max="80"
                              v-model.number="demandApply.AgeRangeStart"
                            />
                            <span class="text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                        ~
                        <div class="col-md">
                          <ValidationProvider
                            tag="section"
                            name="年齡(最高)"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <el-input-number
                              class="w-100"
                              :min="18"
                              :max="80"
                              v-model.number="demandApply.AgeRangeEnd"
                            />
                            <span class="text-danger">{{ errors[0] }}</span>
                          </ValidationProvider>
                        </div>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-right">性別</td>
                    <td>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="不拘"
                            v-model="demandApply.Sex"
                          />
                          不拘
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="男"
                            v-model="demandApply.Sex"
                          />
                          男
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            type="radio"
                            value="女"
                            v-model="demandApply.Sex"
                          />
                          女
                        </label>
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td class="text-right">駕照</td>
                    <td>
                      <el-cascader
                        class="w-100"
                        :options="driverLicenseOptions"
                        clearable
                        filterable
                        :props="props"
                        :show-all-levels="false"
                        @change="driverLicensesChange"
                        v-model="manpowerDemandDriverLicense"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td class="text-right">證照</td>
                    <td>
                      <el-cascader
                        class="w-100"
                        :options="certificateOptions"
                        clearable
                        filterable
                        :props="props"
                        :show-all-levels="false"
                        :filter-method="certificationsFilter"
                        @change="certificationsChange"
                        v-model="chooseCertifications"
                      />
                      <ValidationProvider
                        v-if="certificateOther"
                        tag="section"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <textarea
                          v-model="certificateDescription"
                          class="form-control mt-2"
                          rows="5"
                        />
                        <span class="text-danger">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </td>
                  </tr>

                  <tr>
                    <td colspan="1" class="text-right">其他條件</td>
                    <td colspan="3">
                      <el-input
                        type="textarea"
                        :rows="6"
                        maxlength="500"
                        show-word-limit
                        v-model="demandApply.OtherConditions"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </fieldset>

          <div class="button-wrap center">
            <button
              v-if="currentStep !== 1"
              type="button"
              class="btn btn-secondary"
              @click.stop.prevent="currentStep -= 1"
            >
              {{ i18n("Buttons.Back") }}
            </button>
            <button
              v-else
              type="button"
              class="btn btn-secondary"
              data-toggle="modal"
              data-target="#historyModal"
              @click.self="(selectedDemand = null), $refs.historyDemand.reset()"
            >
              {{ i18n("Buttons.CopyDemandData") }}
            </button>
            <button
              type="submit"
              class="btn btn-success"
              style="margin-left: 5px"
            >
              <span v-if="currentStep !== 5">{{ i18n("Buttons.Next") }}</span>
              <span v-if="currentStep === 5">儲存</span>
            </button>
            <button
              v-if="currentStep === 5"
              type="button"
              class="btn btn-info"
              style="margin-left: 5px"
              @click="(manpowerDemandStatus = 'Pending'), saveDemand()"
            >
              送出
            </button>
          </div>
        </form>
      </ValidationObserver>
    </div>

    <!--歷史需求單 Modal-->
    <div
      class="modal fade"
      id="historyModal"
      data-focus="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <ValidationObserver v-slot="{ handleSubmit }">
            <div class="modal-header">
              <h6 class="modal-title">
                {{ i18n("DemandApply.HistoryDemand") }}
              </h6>
            </div>
            <div class="modal-body" style="height: 250px">
              <div class="row">
                <div class="col-md-10">
                  <ValidationProvider
                    ref="historyDemand"
                    class="w-100"
                    :name="i18n('DemandApply.HistoryDemand')"
                    v-slot="{ errors }"
                    rules="required"
                  >
                    <el-select
                      class="w-100"
                      filterable
                      value-key="ManpowerDemandNo"
                      placeholder="請選擇"
                      v-model="selectedDemand"
                    >
                      <el-option
                        v-for="demand in demandHistoryOptions"
                        :key="demand.ManpowerDemandNo"
                        :label="
                          demand.ManpowerDemandNo + ' ' + demand.PositionName
                        "
                        :value="demand"
                      >
                      </el-option>
                    </el-select>
                    <p v-if="errors[0]" class="text-danger">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
                <div class="col-md-2">
                  <button
                    v-if="selectedDemand"
                    type="button"
                    class="btn btn-primary btn-sm"
                    @click="
                      $store.commit(
                        'OpenDemandDetailModal',
                        selectedDemand.ManpowerDemandNo
                      )
                    "
                  >
                    {{ i18n("Buttons.View") }}
                  </button>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(getHistoryDemandDetail)"
              >
                {{ i18n("Buttons.Confirm") }}
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>

    <!-- 檢視需求單 -->
    <DemandDetailModal />
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import AddLanguage from "@/components/back/DemandForm/AddLanguage.vue";
import AddDialect from "@/components/back/DemandForm/AddDialect.vue";
import AddMajor from "@/components/back/DemandForm/AddMajor.vue";

import DemandDetailModal from "@/components/back/Modal/DemandDetail";

export default {
  name: "DemandForm",

  components: {
    AddLanguage,
    AddDialect,
    AddMajor,
    DemandDetailModal,
  },
  data() {
    return {
      // compositionstart & compositionend
      is_composing: false,

      // 當前頁面
      currentStep: 1,

      // 歷史需求單
      demandHistoryOptions: [],
      selectedDemand: null,
      showDemandDetail: false,

      // 履歷類型
      resumeTypeOptions: [],

      // 元件
      addMajor: false, // 新增科系
      addLanguage: false, // 新增外語
      addDialect: false, //新增方言

      // 部門列表(treeSelect)
      departmentOptions: [],

      // 職務列表
      positionOptions: [],
      positionValue: null,

      // 薪資類型
      salaryTypeOptions: [],
      salaryTypeValue: null,

      // 工作地點列表
      workplaceOptions: [],

      // 班別
      originalShiftOptions: [],
      shiftOptions: [],

      // 招募方式
      recruitmentMethodOptions: [],
      recruitmentMethodOtherStatus: false, // 招募狀態是否選其他
      recruitmentMethodDescription: null, // 招募方式描述

      // 學歷程度
      educationDegreeOptions: [],

      // 需求單狀態(儲存or送出)
      manpowerDemandStatus: null,

      // 證照
      certificateOptions: [],
      certificateOther: false,
      certificateDescription: null,
      chooseCertifications: [],

      // 駕照
      driverLicenseOptions: [],
      manpowerDemandDriverLicense: [],

      // 員工
      contactorOptions: [],
      supervisorOptions: [],
      supervisorData: null, // (Guid & Name)

      // 需求單 data
      demandApply: {
        ManpowerDemandName: null, // 職缺名稱
        DemandDepartmentGuid: null, // 需求部門Guid
        ApplicantTime: this.$common.getToday(),
        ApplicantGuid: this.$cookies.get("userId"), // 申請者Guid
        Applicant: this.$cookies.get("userName"), // 申請者
        PositionProperty: "全職", // 職務性質
        PositionCode: null, // 職務代碼
        PositionName: null, // 職務名稱
        PositionContactor: null, // 職務聯絡人
        PositionContactorEmail: null, // 職務聯絡人Email
        DemandNumber: 1, // 需求人數
        OnBoard: this.dayjs().add(1, "month").format("YYYY-MM-DD"), // 預定任職日
        ContractType: "一般", // 合約類別
        WorkContent: null, // 工作內容
        Description: null, // 說明
        ManagementResponsibility: false, // 管理責任
        ManagementNumber: 1, // 管理人數
        BusinessTrip: false, // 出差
        OverseasWork: false, // 外派
        Shift: false, // 輪班
        SalaryType: null, // 薪資類型
        SalaryTypeGuid: null, // 薪資類型Guid
        SalaryTypeDescription: null, // 薪資類型描述(選擇其他填寫之內容)
        SalaryLow: null, // 工作待遇(低)
        SalaryHigh: null, // 工作待遇(高)
        AppointmentDefaultSalary: null,
        WorkExperience: 1, // 工作經驗(年)
        WorkExperienceWhatever: true, // 工作經驗(不拘)
        EducationDemandWhatever: true, // 學歷要求(不拘)
        SchoolDepartmentWhatever: true, // 科系要求(不拘)
        AgeRangeStart: 18, // 年齡起
        AgeRangeEnd: 80, // 年齡迄
        AgeRangeWhatever: true, // 年齡(不拘)
        Sex: "不拘", // 性別
        OtherConditions: null, // 其他條件
        ResumeType: null, // 履歷類型
        RecruitmentDeadline: this.dayjs().add(3, "month").format("YYYY-MM-DD"), // 招募期限(預設三個月)
        ManpowerDemandRecruitmentMethod: [], // 招募方式
        ManpowerDemandWorkShiftType: [], // 班別
        ManpowerDemandEducationDegree: [], // 學歷要求
        ManpowerDemandDialect: [], // 方言
        ManpowerDemandLanguage: [], // 外語
        ManpowerDemandSchoolDepartment: [], // 科系
        ManpowerDemandCertificate: [], // 證照
        ManpowerDemandDriverLicense: [], // 駕照
        ManpowerDemandWorkPlace: [], // 工作地點
      },
      // el-cascader
      props: { multiple: true },
    };
  },

  methods: {
    // 帶入歷史需求單 data
    getHistoryDemandDetail() {
      // 目前有的部門
      let allDepartments = [];
      JSON.stringify(this.departmentOptions, function (k, v) {
        if (k === "DepartmentGuid") allDepartments.push(v);
        return v;
      });

      $("#historyModal").modal("hide");
      this.updateLoading(true);
      this.$api.manpowerDemand
        .getManpowerDemandDetail(this.selectedDemand.Guid)
        .then((response) => {
          if (response.status === 200) {
            this.demandApply = response.data;
            // 部門
            const findDepartment = allDepartments.indexOf(
              response.data.DemandDepartmentGuid
            );
            if (findDepartment === -1) {
              this.demandApply.DemandDepartmentGuid = null;
            }

            this.demandApply.ApplicantTime = this.$common.getToday();
            this.demandApply.RecruitmentDeadline = this.dayjs()
              .add(3, "month")
              .format("YYYY-MM-DD");
            this.demandApply.OnBoard = this.dayjs()
              .add(1, "month")
              .format("YYYY-MM-DD");

            // 職務
            const positionCodeList = this.positionOptions.map(
              (item) => item.PositionCode
            );
            const findPosition = positionCodeList.indexOf(
              response.data.PositionCode
            );
            if (findPosition === -1) {
              this.positionValue = null;
            } else {
              this.positionValue = {
                PositionCode: this.demandApply.PositionCode,
                PositionName: this.demandApply.PositionName,
              };
            }

            // 招募方式(其他)
            this.demandApply.ManpowerDemandRecruitmentMethod.forEach((item) => {
              if (item.RecruitmentMethodDescription) {
                this.recruitmentMethodDescription =
                  item.RecruitmentMethodDescription;
              }
            });
            this.demandApply.ManpowerDemandRecruitmentMethod =
              this.recruitmentMethodOptions.filter((o1) =>
                this.demandApply.ManpowerDemandRecruitmentMethod.some(
                  (o2) => o1.RecruitmentMethodGuid === o2.RecruitmentMethodGuid
                )
              );

            // 工作地點
            this.demandApply.ManpowerDemandWorkPlace =
              this.demandApply.ManpowerDemandWorkPlace.map((item) => {
                return {
                  WorkPlaceGuid: item.WorkPlaceGuid,
                  WorkPlace: item.WorkPlace,
                };
              });

            // 班別
            this.demandApply.ManpowerDemandWorkShiftType =
              this.demandApply.ManpowerDemandWorkShiftType.map((item) => {
                return {
                  WorkShiftTypeGuid: item.WorkShiftTypeGuid,
                  WorkShiftType: item.WorkShiftType,
                  WorkShiftTypeDescription: item.WorkShiftTypeDescription,
                };
              });
            this.shiftOptions = this.originalShiftOptions.map((item) => {
              return { ...item };
            });
            this.shiftOptions.forEach((o1, index, arr) => {
              this.demandApply.ManpowerDemandWorkShiftType.map((o2) => {
                if (o2.WorkShiftTypeGuid === o1.WorkShiftTypeGuid) {
                  arr[index].WorkShiftTypeDescription =
                    o2.WorkShiftTypeDescription
                      ? o2.WorkShiftTypeDescription
                      : null;
                }
              });
            });

            // 薪資類型
            this.salaryTypeValue = {
              Code: this.demandApply.SalaryTypeDescription ? "other" : null,
              Guid: this.demandApply.SalaryTypeGuid,
              Name: this.demandApply.SalaryType,
            };
            this.salaryTypeDescription = this.demandApply.SalaryTypeDescription;

            // 學歷
            this.demandApply.ManpowerDemandEducationDegree =
              this.educationDegreeOptions.filter((o1) =>
                this.demandApply.ManpowerDemandEducationDegree.some(
                  (o2) => o1.EducationDegreeGuid === o2.EducationDegreeGuid
                )
              );

            // 職務聯絡人
            this.demandApply.PositionContactor = {
              Name: this.demandApply.PositionContactor,
              Email: this.demandApply.PositionContactorEmail,
            };

            // 證照來源(扁平化)
            const flatten = (data) => {
              return data.reduce((r, { children, ...rest }) => {
                r.push(rest);
                if (children) r.push(...flatten(children));
                return r;
              }, []);
            };
            let flatCertifications = flatten(this.certificateOptions);
            let filterCertifications = flatCertifications.filter((o1) =>
              this.demandApply.ManpowerDemandCertificate.some(
                (o2) => o1.value.split("+")[0] === o2.CertificateGuid
              )
            );
            this.demandApply.ManpowerDemandCertificate.forEach(
              (o1, index, arr) =>
                filterCertifications.map((o2) => {
                  if (o1.CertificateGuid === o2.value.split("+")[0]) {
                    arr[index].CertificateCode = o2.value.split("+")[2];
                  }
                })
            );

            // 證照 el-cascader
            this.chooseCertifications =
              this.demandApply.ManpowerDemandCertificate.map((category) => {
                return [
                  `${category.CertificateCategoryTop}`,
                  `${category.CertificateCategorySecond}`,
                  `${category.CertificateGuid}+${category.Certificate}+${category.CertificateCode}`,
                ];
              });
            // 證照 array
            this.demandApply.ManpowerDemandCertificate =
              this.demandApply.ManpowerDemandCertificate.map((item) => {
                if (item.CertificateDescription) {
                  this.certificateOther = true;
                  this.certificateDescription = item.CertificateDescription;
                }
                return {
                  CertificateCategoryTop: item.CertificateCategoryTop,
                  CertificateCategorySecond: item.CertificateCategorySecond,
                  CertificateGuid: item.CertificateGuid,
                  Certificate: item.Certificate,
                  CertificateCode: item.CertificateCode,
                  CertificateDescription: item.CertificateDescription,
                };
              });

            // 駕照 el-cascader
            this.manpowerDemandDriverLicense =
              this.demandApply.ManpowerDemandDriverLicense.map((category) => {
                return [
                  `${category.DriverLicenseCategory}`,
                  `${category.DriverLicenseGuid}+${category.DriverLicense}`,
                ];
              });
            // 駕照 array
            this.demandApply.ManpowerDemandDriverLicense =
              this.demandApply.ManpowerDemandDriverLicense.map((item) => {
                return {
                  DriverLicenseCategory: item.DriverLicenseCategory,
                  DriverLicenseGuid: item.DriverLicenseGuid,
                  DriverLicense: item.DriverLicense,
                };
              });
          }
          this.updateLoading(false);
        });
    },

    // 建立需求單 API
    saveDemand() {
      if (this.currentStep !== 5) {
        this.currentStep += 1;
        return;
      }

      if (this.salaryTypeValue?.Code !== "other") {
        this.demandApply.SalaryTypeDescription = null;
      }

      const data = this._prepareDemandData();

      this.updateLoading(true);
      this.$api.manpowerDemand.postManpowerDemand(data).then((response) => {
        if (response.status === 200) {
          this.$notify({
            title: "成功",
            message: "需求單建立成功",
            type: "success",
            duration: 2000,
          });
          this.$router.push({
            path: `/manager/recruitment/personalapplication`,
          });
        }
        this.updateLoading(false);
      });
    },

    _prepareDemandData() {
      const cleaned = { ...this.demandApply };

      cleaned.PositionContactor = cleaned.PositionContactor.Name;
      cleaned.ManpowerDemandStatus = this.manpowerDemandStatus;

      // 職務
      cleaned.PositionCode = this.positionValue.PositionCode;
      cleaned.PositionName = this.positionValue.PositionName;

      // 招募方式
      cleaned.ManpowerDemandRecruitmentMethod =
        cleaned.ManpowerDemandRecruitmentMethod.map((item) => ({
          RecruitmentMethodGuid: item.RecruitmentMethodGuid,
          RecruitmentMethod: item.RecruitmentMethod,
          RecruitmentMethodDescription:
            item.RecruitmentMethodCode === "other"
              ? this.recruitmentMethodDescription
              : null,
        }));

      // 薪資
      cleaned.SalaryTypeGuid = this.salaryTypeValue.Guid;
      cleaned.SalaryType = this.salaryTypeValue.Name;

      cleaned.SalaryLow = this._toNumberOrNull(cleaned.SalaryLow);
      cleaned.SalaryHigh = this._toNumberOrNull(cleaned.SalaryHigh);
      cleaned.AppointmentDefaultSalary = this._toNumberOrNull(
        cleaned.AppointmentDefaultSalary
      );

      // 學歷
      if (cleaned.EducationDemandWhatever) {
        cleaned.ManpowerDemandEducationDegree = [];
      }

      // 科系
      if (cleaned.ManpowerDemandSchoolDepartment.length > 0) {
        cleaned.SchoolDepartmentWhatever = false;
      }

      // 管理人數
      if (!cleaned.ManagementResponsibility) {
        cleaned.ManagementNumber = null;
      }

      // 年齡
      if (cleaned.AgeRangeWhatever) {
        cleaned.AgeRangeStart = null;
        cleaned.AgeRangeEnd = null;
      }

      // 工作年資
      if (cleaned.WorkExperienceWhatever) {
        cleaned.WorkExperience = null;
      }

      // 證照
      cleaned.ManpowerDemandCertificate = cleaned.ManpowerDemandCertificate.map(
        (item) => ({
          ...item,
          CertificateDescription:
            item.CertificateCode === "other"
              ? this.certificateDescription
              : null,
        })
      );

      return cleaned;
    },

    _toNumberOrNull(value) {
      return value ? Number(value.replace(/,/g, "")) : null;
    },

    // 選擇 聯絡人
    changeContactor(person) {
      if (typeof person === "string") {
        const contactor = {
          Guid: `${person.substring(0, 3)}-${crypto.randomUUID()}`,
          Name: person,
        };
        this.contactorOptions.push(contactor);
        this.demandApply.PositionContactor = contactor;
        this.demandApply.PositionContactorEmail = null;
      } else {
        this.demandApply.PositionContactorEmail = person.Email
          ? person.Email
          : null;
      }
    },

    // 證照搜尋關鍵字(不區分大小寫)
    certificationsFilter(node, keyword) {
      if (
        !!~node.text.indexOf(keyword) ||
        !!~node.text.toUpperCase().indexOf(keyword.toUpperCase())
      ) {
        return true;
      }
    },

    // 證照選擇
    certificationsChange(value) {
      if (value.length === 0) {
        this.certificateOther = false;
        this.certificateDescription = null;
      } else {
        let findOther = value
          .map((item) => {
            return item[2].split("+")[2];
          })
          .indexOf("other");
        if (findOther === -1) {
          this.certificateOther = false;
          this.certificateDescription = null;
        } else {
          this.certificateOther = true;
        }
        this.demandApply.ManpowerDemandCertificate = value.map((item) => {
          return {
            CertificateCategoryTop: item[0],
            CertificateCategorySecond: item[1],
            CertificateGuid: item[2].split("+")[0],
            Certificate: item[2].split("+")[1],
            CertificateCode: item[2].split("+")[2],
            CertificateDescription:
              item[2].split("+")[2] === "other"
                ? this.certificateDescription
                : null,
          };
        });
      }
    },

    // 駕照選擇
    driverLicensesChange(value) {
      this.demandApply.ManpowerDemandDriverLicense = value.map((item) => {
        return {
          DriverLicenseCategory: item[0],
          DriverLicenseGuid: item[1].split("+")[0],
          DriverLicense: item[1].split("+")[1],
        };
      });
    },

    // 新增 科系 & 語言 & 方言 元件
    addItem(category) {
      switch (category) {
        case "Language":
          this.addLanguage = true;
          break;
        case "Dialect":
          this.addDialect = true;
          break;
        case "Education":
          this.addMajor = true;
          break;
      }
    },

    // 取消新增 科系 & 語言 & 方言 元件
    cancelItem(category) {
      switch (category) {
        case "Language":
          this.addLanguage = false;
          break;
        case "Dialect":
          this.addDialect = false;
          break;
        case "Education":
          this.addMajor = false;
          break;
      }
    },

    // 儲存 科系 & 語言 & 方言 元件
    saveItem(item, type) {
      switch (type) {
        case "Language":
          this.addLanguage = false;
          this._saveToList(this.demandApply.ManpowerDemandLanguage, item, [
            "LanguageGuid",
            "LanguageDescription",
          ]);
          break;

        case "Dialect":
          this.addDialect = false;
          this._saveToList(this.demandApply.ManpowerDemandDialect, item, [
            "DialectGuid",
            "DialectDescription",
          ]);
          break;

        case "Education":
          this.addMajor = false;
          this._saveEducationItem(item);
          break;
      }
    },

    // 儲存 科系 & 語言 & 方言 元件
    _saveToList(list, item, keys) {
      const index = list.findIndex((element) =>
        keys.every((key) => element[key] === item[key])
      );

      if (index === -1) {
        list.push({ ...item });
      } else {
        list.splice(index, 1, { ...item });
      }
    },

    // 儲存 科系 & 語言 & 方言 元件
    _saveEducationItem(item) {
      const list = this.demandApply.ManpowerDemandSchoolDepartment;

      if (item.SchoolDepartmentGuid !== null) {
        const sameTypeIndex = list.findIndex(
          (element) =>
            element.SchoolDepartmentType === item.SchoolDepartmentType &&
            element.SchoolDepartmentGuid === null
        );

        const existingIndex = list.findIndex(
          (element) =>
            element.SchoolDepartmentGuid === item.SchoolDepartmentGuid
        );

        if (sameTypeIndex === -1) {
          if (existingIndex === -1) {
            list.push({ ...item });
          } else {
            list.splice(existingIndex, 1, { ...item });
          }
        }
      } else {
        // Remove any with the same type
        this.demandApply.ManpowerDemandSchoolDepartment = list.filter(
          (dept) => dept.SchoolDepartmentType !== item.SchoolDepartmentType
        );
        this.demandApply.ManpowerDemandSchoolDepartment.push({ ...item });
      }
    },

    // 刪除 科系 & 語言 & 方言 元件
    deleteItem(itemIndex, category) {
      switch (category) {
        case "Language":
          this.demandApply.ManpowerDemandLanguage.forEach((item, index) => {
            if (itemIndex === index) {
              this.demandApply.ManpowerDemandLanguage.splice(index, 1);
            }
          });
          break;
        case "Dialect":
          this.demandApply.ManpowerDemandDialect.forEach((item, index) => {
            if (itemIndex === index) {
              this.demandApply.ManpowerDemandDialect.splice(index, 1);
            }
          });
          break;
        case "Education":
          this.demandApply.ManpowerDemandSchoolDepartment.forEach(
            (item, index) => {
              if (itemIndex === index) {
                this.demandApply.ManpowerDemandSchoolDepartment.splice(
                  index,
                  1
                );
              }
            }
          );
          break;
      }
    },

    async getData() {
      try {
        // 取得 部門選項
        const department = await this.$api.department.getDepartment();
        this.departmentOptions = department.data;

        // 取得 歷史需求單
        const job = await this.$api.recruitment.getJobs();
        this.demandHistoryOptions = job.data;

        // 取得 履歷類型
        const type = await this.$api.resume.getResumeType();
        this.resumeTypeOptions = type.data
          .filter((type) => type.IsEnabled === true)
          .map((item) => {
            return {
              Type: item.Type,
              Name: item.Name,
            };
          });

        // 取得 職務選項
        const position = await this.$api.position.getPositionPaging({
          isPaging: false,
        });
        this.positionOptions = position.data.Datas.map((item) => {
          return {
            PositionCode: item.PositionCode,
            PositionName: item.PositionName,
          };
        });

        // 取得 工作地點
        const workplace = await this.$api.workplace.getWorkplacePaging({
          isPaging: false,
        });
        this.workplaceOptions = workplace.data.Datas.map((item) => {
          return {
            WorkPlaceGuid: item.Guid,
            WorkPlace: item.WorkPlaceName,
          };
        });

        // 取得 班別選項
        const shift = await this.$api.workShift.getWorkShift();
        this.originalShiftOptions = shift.data.map((item) => {
          return {
            WorkShiftTypeGuid: item.Guid,
            WorkShiftType: item.Name,
            WorkShiftTypeDescription: null,
          };
        });

        // 取得 招募方式
        const method = await this.$api.recruitmentMethod.getRecruitmentMethod();
        this.recruitmentMethodOptions = method.data.map((item) => {
          return {
            RecruitmentMethodCode: item.Code,
            RecruitmentMethodGuid: item.Guid,
            RecruitmentMethod: item.Name,
          };
        });

        // 取得 主管選項
        const backgroundUser =
          await this.$api.backgroundUser.getBackgroundUser();
        this.supervisorOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
          };
        });
        this.contactorOptions = backgroundUser.data.map((user) => {
          return {
            Guid: user.UserId,
            Name: user.Name,
            Email: user.Email,
          };
        });

        // 取得 學歷程度
        const educationDegree = await this.$api.education.getEducationDegree();
        this.educationDegreeOptions = educationDegree.data.map((item) => {
          return {
            EducationDegreeGuid: item.Guid,
            EducationDegree: item.Name,
          };
        });

        // 取得 薪資類型
        const salary = await this.$api.salaryType.getSalaryType();
        this.salaryTypeOptions = salary.data.map((item) => {
          return {
            Code: item.Code,
            Guid: item.Guid,
            Name: item.Name,
          };
        });

        // 取得 駕照選項
        const driverLicense = await this.$api.driverLicense.getDriverLicense();
        this.driverLicenseOptions = driverLicense.data.map((category) => {
          return {
            label: category.Name,
            value: category.Name,
            children: category.DriverLicenses.map((driverLicense) => {
              return {
                label: driverLicense.Name,
                value: `${driverLicense.Guid}+${driverLicense.Name}`,
              };
            }),
          };
        });

        // 取得 證照選項
        const certificate = await this.$api.certificate.getCertificate();
        this.certificateOptions = certificate.data.map((type) => {
          return {
            label: type.Name,
            value: type.Name,
            children: type.Children.map((category) => {
              return {
                label: category.Name,
                value: category.Name,
                children: category.Certificates.map((certificate) => {
                  return {
                    label: certificate.Name,
                    value: `${certificate.Guid}+${certificate.Name}+${certificate.Code}`,
                  };
                }),
              };
            }),
          };
        });
      } catch (error) {
        this.$notify({
          title: error.name,
          message: error.message + "請聯繫系統管理員",
          type: "error",
          duration: 0,
        });
      }
    },

    // loading
    ...mapActions(["updateLoading"]),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  watch: {
    // 職務名稱
    "demandApply.PositionProperty": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.positionValue = null;
        const position = this.$api.position.getPositionPaging({
          isPaging: false,
        });
        this.positionOptions = position.data.Datas.map((item) => {
          return {
            PositionCode: item.PositionCode,
            PositionName: item.PositionName,
          };
        });
      }
    },
    // 招募方式
    "demandApply.ManpowerDemandRecruitmentMethod": function (e) {
      const arr = e.map((item) => item.RecruitmentMethodCode);
      if (arr.includes("other")) {
        this.recruitmentMethodOtherStatus = true;
      } else {
        this.recruitmentMethodOtherStatus = false;
        this.recruitmentMethodDescription = null;
      }
    },
    // 薪資待遇(低)
    "demandApply.SalaryLow": function (newVal) {
      if (newVal) {
        this.demandApply.SalaryLow = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },
    // 薪資待遇(高)
    "demandApply.SalaryHigh": function (newVal) {
      if (newVal) {
        this.demandApply.SalaryHigh = this.$common.currencyThousands(
          String(newVal)
        );
      }
    },
    // 預設薪資
    "demandApply.AppointmentDefaultSalary": function (newVal) {
      if (newVal) {
        this.demandApply.AppointmentDefaultSalary =
          this.$common.currencyThousands(String(newVal));
      }
    },
    // 證照
    "demandApply.ManpowerDemandCertificate": function (newVal, oldVal) {
      if (newVal !== oldVal) {
        const foundOther = newVal.filter((item) => {
          return item.CertificateCode.indexOf("other") === 0;
        });
        if (foundOther.length === 0) {
          this.certificateDescription = null;
        }
      }
    },

    // 選擇歷史需求單
    selectedDemand: function (newVal) {
      if (newVal === null) {
        this.showDemandDetail = false;
      }
    },
  },

  created() {
    this.getData();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.width-15 {
  width: 15%;
}
.width-35 {
  width: 35%;
}
th {
  font-weight: normal;
}
.form-check-label {
  cursor: pointer;

  .form-check-input {
    line-height: unset;
    height: unset;
    margin-right: 0 !important;
  }
}
.cursor-auto {
  cursor: auto;
}
</style>
